import { FC } from "react";
import { FormProvider } from "react-hook-form";

import { CaseFilterableSinglePicker } from "src/components/Pickers/CaseFilterableSinglePicker";
import RuleSinglePickerFormField from "src/components/Pickers/RuleSinglePickerFormField";
import { useT } from "src/internationalization";

import { ExecutionParametersFormControl } from "./useExecutionParametersForm";

export type ExecutionParametersFormProps = {
  executionParametersFormControl: ExecutionParametersFormControl;
  caseTypeCode: string;
};

export const ExecutionParametersForm: FC<ExecutionParametersFormProps> = ({
  executionParametersFormControl,
  caseTypeCode,
}) => {
  const t = useT();
  const { methods } = executionParametersFormControl;

  return (
    <FormProvider {...methods}>
      <div className="flex flex-col gap-6 py-5">
        <RuleSinglePickerFormField
          id="rule-picker"
          name="rule"
          caseTypeCode={caseTypeCode}
          titleText={t("page.cases.executeRule.modal.step1.rule.title")}
          placeholder={t("page.cases.executeRule.modal.step1.rule.placeholder")}
          helperText={t("page.cases.executeRule.modal.step1.rule.helper", {
            case: methods.getValues("caseItem")?.request ?? "",
          })}
        />

        <CaseFilterableSinglePicker
          id="case-picker"
          name="caseItem"
          label={t("page.cases.executeRule.modal.step1.case.title")}
          placeholder={t("page.cases.executeRule.modal.step1.case.placeholder")}
          helperText={t("page.cases.executeRule.modal.step1.case.helper")}
          caseTypeCodes={[caseTypeCode]}
          rules={{
            required: {
              value: true,
              message: t("general.form.field.required"),
            },
          }}
        />
      </div>
    </FormProvider>
  );
};
